export const areaBound = {
    north: 22.7932,
    south: 22.4593,
    east: 88.5167,
    west: 88.2957,
}

export const Services = {
    PatientCare: {
        display: 'Care for elderly or bedridden patient',
        details: '',
        serviceTime: {
            halfDay: { display: 'Eight hours per day', rate: 320 },
            fullDay: { display: 'Twelve hours per day', rate: 380 }
        }
    },
    BabyCare: {
        display: 'Care for children upto 5 years of age',
        details: '',
        serviceTime: {
            halfDay: { display: 'Eight hours per day', rate: 320 },
            fullDay: { display: 'Twelve hours per day', rate: 380 }
        }
    },
    Dusting: {
        display: 'Dusting',
        details: '',
        serviceTime: {
            oncePerDay: { display: 'One Time per day(60 mins)', rate: 150 },
        }
    },
    Cooking: {
        display: 'Personal Chef',
        details: '',
        serviceTime: {
            oncePerDay: { display: 'One-time per day(60 mins)', rate: 150 },
            twicePerDay: { display: 'Two-time per day(60 mins x2)', rate: 300 }
        }
    },
    Housekeeping: {
        display: 'Housekeeping',
        details: '',
        serviceTime: {
            oncePerDay: { display: 'Eight hours per day', rate: 320 },
            twicePerDay: { display: 'Twelve hours per day', rate: 380 },
        }
    }
}
export const Packages = {
    None: { display: 'None', discount: 1 },
    OneWeek: { display: 'For one week or more (save 10%)', discount: 0.9 },
    OneMonth: { display: 'For one month or more (save 15%)', discount: 0.85 }
}
export const calculatePrice = (service, duration, packageType = 'None', numDays = 1) => {
    if (service == '' || duration == '' || packageType == '') return 0;
    const serviceChargeRate = .06, gstEssential = 0.05, gstService = 0.18;
    return Services[service].serviceTime[duration].rate * ((1 + gstEssential) + serviceChargeRate * (1 + gstService)) * Packages[packageType].discount * numDays;
}
export const consultNotificationSettings = {
    customerCareEmail: "bigyanm@welfarex.com",
    firestoreCollection: "NotificationEmail",
    htmlTemplate: (req)=>{ return `<br/>Name : ${req.name} <br/>Phone: ${req.phone}` }
}